import React from 'react'
import {
  CardStyleInterpolators,
  createStackNavigator,
  StackNavigationOptions,
} from '@react-navigation/stack'
import {
  AdminModal,
  PasswordResetRequestScreen,
  PasswordResetRequestSuccessScreen,
  PasswordResetScreen,
  SignInOrSignUpScreen,
  SignInScreen,
} from '@screens'
import { useReducedMotion } from '@src/config/accessibility'
import {
  CreateAccountScreen,
  CreateAccountOptionsScreen,
  CreateAccountOptionsSteloScreen,
  CreateAccountSteloScreen,
  OnboardingSubscriptionOptionsScreen,
} from '@src/screens/SignUp'
import {
  ReferralVideoCallReservedScreen,
  ReferralVideoCallScreen,
} from '@src/screens/NutritionistHub'
import { fadeFromBottomModalOptions } from '../utils'
import { AuthStackParamList } from '../types'

const AuthStack = createStackNavigator<AuthStackParamList>()

export const AuthNavigator = () => {
  const reduceMotionEnabled = useReducedMotion()

  const screenOptions: StackNavigationOptions = {
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
  }

  if (reduceMotionEnabled) {
    screenOptions.animation = 'none'
  }

  return (
    <AuthStack.Navigator initialRouteName="SignInOrSignUp" screenOptions={screenOptions}>
      <AuthStack.Screen name="SignInOrSignUp" component={SignInOrSignUpScreen} />
      <AuthStack.Screen name="SignIn" component={SignInScreen} />
      <AuthStack.Screen name="CreateAccount" component={CreateAccountScreen} />
      <AuthStack.Screen name="CreateAccountStelo" component={CreateAccountSteloScreen} />
      <AuthStack.Screen name="CreateAccountOptions" component={CreateAccountOptionsScreen} />
      <AuthStack.Screen
        name="CreateAccountOptionsStelo"
        component={CreateAccountOptionsSteloScreen}
      />
      <AuthStack.Screen
        name="OnboardingSubscriptionOptions"
        component={OnboardingSubscriptionOptionsScreen}
      />
      <AuthStack.Screen name="PasswordResetRequest" component={PasswordResetRequestScreen} />
      <AuthStack.Screen name="PasswordReset" component={PasswordResetScreen} />
      <AuthStack.Screen
        name="PasswordResetRequestSuccess"
        component={PasswordResetRequestSuccessScreen}
      />
      <AuthStack.Screen
        name="ShowAdmin"
        component={AdminModal}
        options={fadeFromBottomModalOptions}
      />
      <AuthStack.Screen name="ReferralVideoCall" component={ReferralVideoCallScreen} />
      <AuthStack.Screen
        name="ReferralVideoCallReserved"
        component={ReferralVideoCallReservedScreen}
      />
    </AuthStack.Navigator>
  )
}
